export const SET_ACTIVE_FILTER = 'SET_ACTIVE_FILTER';
export const SET_FILTER_REPLICA = 'SET_FILTER_REPLICA';
export const RESET_ACTIVE_FILTER = 'RESET_ACTIVE_FILTER';
export const CALL_CLOSE_CAROUSEL = 'CALL_CLOSE_CAROUSEL';

const initialState = {
  activeFilter: '',
  activeFilterReplica: [],
  shouldCloseCarousel: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {

    case SET_ACTIVE_FILTER :
      return {
        ...state,
        activeFilter: action.payload
      };

    case SET_FILTER_REPLICA :
      return {
        ...state,
        activeFilterReplica: action.payload
      };

    case RESET_ACTIVE_FILTER :
      return {
        ...state,
        activeFilter: action.payload.activeFilter,
        activeFilterReplica: action.payload.activeFilterReplica
      };

    case CALL_CLOSE_CAROUSEL :
      return {
        ...state,
        shouldCloseCarousel: action.payload
      };

    default:
      return state;
  }
}

export const setActiveFilter = filter => (
  {
    type: SET_ACTIVE_FILTER,
    payload: filter
  }
);

export const replicateActiveFilter = replica => (
  {
    type: SET_FILTER_REPLICA,
    payload: replica
  }
);

export const resetActiveFilter = () => (
  {
    type: RESET_ACTIVE_FILTER,
    payload: initialState
  }
);

export const callCloseCarousel = carousel => (
  {
    type: CALL_CLOSE_CAROUSEL,
    payload: carousel
  }
);



// WEBPACK FOOTER //
// ./src/state/modules/filter.js